/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Offcanvas mobile menu - Adjust menu/close icon on the navbar
document.querySelector('#offcanvas-mobile-menu').addEventListener('show.bs.offcanvas', (e) => {
    document.querySelector('#navbar a[href="#offcanvas-mobile-menu"]').classList.add('open')
})

document.querySelector('#offcanvas-mobile-menu').addEventListener('hide.bs.offcanvas', (e) => {
    document.querySelector('#navbar a[href="#offcanvas-mobile-menu"]').classList.remove('open')
});

// Carousel - Go to corresponding slide on editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

// Parallax with text
const initParallaxWithText = () => {
    document.querySelectorAll('.parallax-with-text.jarallax:not(.init)').forEach(($el) => {
        $el.classList.add('init')

        jarallax($el, {
            speed: Number($el.dataset.parallaxSpeed)
        })
    })
}
initParallaxWithText()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.parallax-with-text.jarallax')) {
        initParallaxWithText()
    }
})

/*
    Product Sticky ATC  - Handle Visibility
*/
const productStickyATCVisibility = () => {
    const $stickyATC = document.querySelector('#product-sticky-atc')
    const $productDetailPage = document.getElementById('product-page')
    const $buttonForm = document.querySelector("#main-add-to-cart")

    if ($stickyATC && $productDetailPage) {
        const threshold = $productDetailPage.clientHeight
        const $htmlEl = document.documentElement
        const stickyATCheight = $stickyATC.clientHeight

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                $stickyATC.classList.remove('show')
                } else {
                $stickyATC.classList.add('show')
                }
            });
        }, { root: null, rootMargin: "0px", threshold: 1.0 });

        if (window.innerWidth < 576) {
            $stickyATC.classList.add("show")

            observer.observe($buttonForm);    
        } else {
            window.addEventListener('scroll', () => {
                if (window.scrollY > threshold) {
                    $stickyATC.classList.add('show')
                    $htmlEl.style.paddingBottom = `${stickyATCheight}px`
                  
                } else {
                    $stickyATC.classList.remove('show')
                    $htmlEl.style.paddingBottom = 0
                   
                }
            })
        }
    }
}
productStickyATCVisibility()

/*
    Product Sticky ATC  - Handle variant change
*/
const productStickyATCVariantChange = () => {
    const $variantSelecetor = document.querySelector('#product-sticky-atc select[name="id"]')

    $variantSelecetor?.addEventListener('change', (e) => {
        const variantImage = $variantSelecetor.options[$variantSelecetor.selectedIndex].dataset.variantImg

        if (variantImage) {
            const $img = $variantSelecetor.closest('#product-sticky-atc').querySelector('.product-img')
            $img.setAttribute('src', variantImage)
        }
    })
}
productStickyATCVariantChange()

/*
    Recommended Products
*/
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('.recommended-products')
    if (recommendedProducts) {
        const {
            sectionId, baseUrl, productId, limit
        } = recommendedProducts.dataset

        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`

        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data

                const $smartShypItem = document.querySelector('.recommended-products [data-is-smartshyp="true"]')

                if ($smartShypItem) {
                    $smartShypItem.remove()
                } else {
                    document.querySelector('.recommended-products [data-is-smartshyp]').remove()
                }
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
});


// Announcement bar fixes
// Change text if coupon is applied
// (() => {
//     let text = document.querySelector('#announcement-bar')?.dataset.discountsText

//     if (text.length) {
//         const myInterval = setInterval(() => {
//             const input = document.querySelector('eg-discount input[type="text"]')

//             if (input) {
//                 if (input.value && input.value.length) {
//                     text = text.replace('[code]', `<b>${input.value}</b>`)
//                     document.querySelector('#announcement-bar .rte').innerHTML = text
//                     clearInterval(myInterval)
//                 }
//             }
//         }, 1000)
//     }
// })()

(() => {
    let text = document.querySelector('#announcement-bar')?.dataset.discountsText

    if (text.length) {
        const myInterval = setInterval(() => {
            const scDiscountData = sessionStorage.getItem('scDiscountData')

            if (scDiscountData) {
                const data = JSON.parse(scDiscountData)
                const code = data.code

                if (code) {
                    text = text.replace('[code]', `<b>${code}</b>`)
                    document.querySelector('#announcement-bar .rte').innerHTML = text
                    clearInterval(myInterval)
                }
            }
        }, 1000)
    }
})();

// Quiz Promo Modal
const initPromoQuizModal = () => {
    const modal = document.querySelector('#quiz-promo-modal')

    if (!modal) { return }

    const { waitDelay, sessionsTrigger, daysIdle } = modal.dataset

    const sessionsCounter = localStorage.getItem('quiz-promo-modal-sessions-counter') || 1

    const lastClosed = localStorage.getItem('quiz-promo-modal-last-closed')

    const bsModal = bootstrap.Modal.getOrCreateInstance('#quiz-promo-modal')

    let showModal = false

    sessionsTrigger.split(',').forEach(number => {
        if (number == sessionsCounter) {
            showModal = true
        }
    })

    if (lastClosed) {
        if (Number(lastClosed) + (daysIdle * 24 * 60 * 60 * 1000) < new Date().getTime()) {
            showModal = true
        }
    } else {
        showModal = true
    }

    if (window.location.href.includes('show-quiz-promo-modal')) {
        showModal = true
    }

    if (showModal) {
        setTimeout(() => {
            bsModal.show()
            localStorage.setItem('quiz-promo-modal-last-closed', new Date().getTime())
        }, Number(waitDelay * 1000))
    }

    localStorage.setItem('quiz-promo-modal-sessions-counter', Number(sessionsCounter) + 1)

}
initPromoQuizModal()
